import { Controller } from '@hotwired/stimulus';
import { initMask } from '../../packs/mask';

// Connects to data-controller="forms--driver-stay"
export default class extends Controller {
  static get targets() {
    return ['valueHourError', 'valueHour', 'input', 'label', 'toggle', 'note', 'messageField', 'message', 'authorized', 'saveButton'];
  }

  static get values() {
    return { locked: Boolean };
  }

  connect() {
    this.applyState();
    initMask();
    this.originalValues = new Map(this.inputTargets.map((input) => [input, input.value]));
  }

  validateValueHour(event) {
    this.valueHourErrorTarget.classList.add('d-none');
    const emptyInputs = this.inputTargets.filter((input) => !input.disabled && input.value.trim() === '');
    if (emptyInputs.length === 0) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.valueHourErrorTarget.classList.remove('d-none');
    emptyInputs.forEach((input) => {
      $(input).val(this.originalValues.get(input)).trigger('change');
    });
    emptyInputs[0].focus();
  }

  toggle() {
    this.applyState();
  }

  applyState() {
    const canEdit = !this.lockedValue;

    this.inputTargets.forEach((input) => {
      input.disabled = !canEdit;
      input.classList.toggle('border-primary', canEdit);
    });

    this.labelTargets.forEach((label) => {
      label.classList.toggle('text-primary', canEdit);
    });
  }

  disapprove() {
    this.messageFieldTarget.classList.remove('d-none');
    this.messageTarget.required = true;
    this.authorizedTarget.value = 'false';
    this.noteTarget.value = '';
    this.noteTarget.disabled = true;

    this.saveButtonTarget.classList.remove('btn-primary');
    this.saveButtonTarget.classList.add('btn-danger');
    this.saveButtonTarget.textContent = 'Confirmar Recusa';
  }

  clearMessage() {
    this.messageFieldTarget.classList.add('d-none');
    this.messageTarget.required = false;
    this.messageTarget.value = '';
    this.noteTarget.value = '';
    this.noteTarget.disabled = false;

    this.saveButtonTarget.classList.remove('btn-danger');
    this.saveButtonTarget.classList.add('btn-primary');
    this.saveButtonTarget.textContent = 'Salvar';
  }

  noteKeyup() {
    const hasContent = this.noteTarget.value.length > 0;

    this.element.querySelectorAll('.btn-auth, .btn-note, .btn-reprove').forEach((btn) => {
      btn.disabled = hasContent;
    });

    if (hasContent) this.authorizedTarget.value = '';
  }
}
